import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useUserStore } from "@roc/feature-app-core";
import { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Tooltip,
  Chip
} from '@material-ui/core';
import { Button } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { alertCircleOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import { useNewLeadStore } from '../../../hooks/useNewLeadStore';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3, 0, 4),
      borderRadius: theme.spacing(2),
      boxShadow:
        'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
      display: 'flex',
      justifyContent: 'center',
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    modalContainer: {
      width: '100%',
      maxWidth: '800px',
      margin: '0 auto',
    },
    buttonContainer: {
      paddingTop: theme.spacing(4),
    },
    contentContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    title: {
      paddingLeft: theme.spacing(2),
      display: 'flex',
      justifyContent: 'flex-start',
    },
    attachmentButtonContainer: {
      display: 'flex',
      flexDirection: 'row-reverse',
      height: '30px'
    },
    textMessage: {
      borderRadius: 15,
      borderTopLeftRadius: 0,
      backgroundColor: '#90EE90',
      display: 'inline-block',
      maxWidth: '100%',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      boxSizing: 'border-box',
      padding: '8px',
    },
    dueChip: {
      backgroundColor: "#9c27b0",
      color: "white",
      padding: "5px 10px",
      borderRadius: "20px",
    },
    tooltip: {
      fontSize: '1.2rem',
    },
  })
);


export const SendTextStepsDueForm = observer(({ handleClose = () => { }, salesforceLeadStore, type, fromGrid, currentStep, cadenceStore }) => {
  const classes = useStyles();
  const { ringCentralStore, createListStore } = salesforceLeadStore;
  const { createListFormStore } = createListStore;
  const { userStore, globalStore } = useStore();
  const { userStore: { userInformation } } = useUserStore();
  const [phoneList, setPhoneList] = useState([]);
  const [sendTo, setSendTo] = useState([]);
  const { newLeadStore } = useNewLeadStore();
  const { userDetailStore } = newLeadStore;
  const portalId = salesforceLeadStore.portalId || userStore.userInformation.portalId;
  const userId = salesforceLeadStore.userId || userStore.userInformation.userId;
  const connectedWithRingCentral = salesforceLeadStore.isSalesForce
    ? salesforceLeadStore.connectedWithRingcentral
    : userInformation.connectedWithRingcentral;

  useEffect(() => {
    ringCentralStore.initSentToOptions(type);
    onEditorChange(currentStep);
    setProspectsPhones(currentStep);
    setSendTo(ringCentralStore.sendToOptions);
    setProspects(currentStep);
    userDetailStore.getUserBusinessUnit();
  }, []);

  const setProspects = (currentStep) => {
    if (!currentStep?.prospects || !Array.isArray(currentStep.prospects)) return;

    currentStep.prospects.forEach(prospect => {
      ringCentralStore.setRecordForCadenceSMS(
        prospect,
        prospect,
        currentStep?.cadenceStepsInfo?.recordType
      );
    });
  };

  useEffect(() => {
    const lead = salesforceLeadStore.getLeadForEmailPreview();
    ringCentralStore.updatePreview(
      ringCentralStore.sendBulkSMSFormStore.form.fields.message.value,
      userStore.userInformation,
      lead
    );
  }, [
    ringCentralStore.sendBulkSMSFormStore.form.fields.message.value,
  ]);

  useEffect(() => {
    createListStore.setFilterCriteriaOptions(
      createListStore.createListFormStore.form.fields.objectType.value
    );
  }, [
    createListStore.createListFormStore.form.fields.objectType.value,
    createListStore.filterCriteriaOptions
  ]);

  const setProspectsPhones = (currentStep?: any) => {
    const phones =
      currentStep?.prospects?.map(p => p?.phoneNumber).filter(Boolean) ?? [];

    setPhoneList(phones);
  };

  const phoneNumber = userInformation?.workphone;

  const onEditorChange = (currentStep) => {
    ringCentralStore.sendBulkSMSFormStore.onFieldChange('message', currentStep?.cadenceStepsInfo?.stepContent?.content);
  }

  const refreshCadenceDashboard = () => {
    cadenceStore.fetchCadencesDueByBackofficeOriginator();
  }

  const handleSendClick = () => {
    const records = ringCentralStore.getRecordList(currentStep?.cadenceStepsInfo?.recordType);
    const recordsWithNoPhone = records.filter(record => ringCentralStore.isPhoneNumberEmpty(record?.phoneNumber));
    recordsWithNoPhone.forEach(record => {
      ringCentralStore.removeCadenceRecords(record, currentStep?.cadenceStepsInfo?.recordType);
    });
    const fields = ringCentralStore.sendBulkSMSFormStore.form.fields;

    if (!(sendTo.length > 0) || !fields.message.value) {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please fill out the form',
      })
    }
    else {

      ringCentralStore.setSendToAll(true);
      ringCentralStore.setRecordType(currentStep?.cadenceStepsInfo?.recordType);
      ringCentralStore.sendSMS(currentStep?.cadenceStepsInfo?.recordType, sendTo, false, userDetailStore.businessUnit, true, handleClose);
    }
  };

  const handleOnClick = async () => {
    await ringCentralStore.getCreds();
    const host = await salesforceLeadStore.getHostByPortaId(portalId);
    ringCentralStore.retriveTokenWithOAuthToken(userId, host);
  };


  return connectedWithRingCentral ? (
    <Grid container spacing={4}>
      {!!ringCentralStore.previewHtml && (
        <Grid item xs={12}>
          <Box mt={1}>
            <Typography variant="h6">From: {phoneNumber}</Typography>
          </Box>

          <Box mt={1}>
            <Typography variant="h6">
              To:{' '}
              <Tooltip
                title={phoneList.join(', ')}
                classes={{ tooltip: classes.tooltip }}
              >
                <Chip
                  className={classes.dueChip}
                  label={`${phoneList.length} numbers`}
                  size="small"
                />
              </Tooltip>
            </Typography>
          </Box>

          <Box p={2} mt={2} className={classes.textMessage}>
            {ringCentralStore.previewHtml}
          </Box>
        </Grid>
      )}

      <Grid item xs={12}>
        <Box display="flex">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendClick}
            style={{ width: '200px', margin: '0 5px' }}
            testId="next"
          >
            Send
          </Button>
        </Box>
      </Grid>
    </Grid>
  ) : (
    <Grid item container className={classes.container}>
      <Grid item>
        <IonIcon slot="end" icon={alertCircleOutline} size="large" />
      </Grid>
      <Grid item>
        <Typography variant="h4">You are not connected to Ringcentral</Typography>
      </Grid>
      <Grid item container className={classes.container}>
        <Box p={3}>
          <Typography variant="body1">
            To send bulk SMS you need to connect your RingCentral account.
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        container
        justifyContent="center"
        className={classes.buttonContainer}
      >
        <Grid item sm={7} md={5} xs={7}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            testId="next"
            onClick={handleOnClick}
          >
            Connect RingCentral
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});


export const SendTextStepDueCadenceModal = observer(({ handleClose, salesforceLeadStore, type, fromGrid = false, currentStep, cadenceStore }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.modalContainer}
    >
      <SendTextStepsDueForm
        handleClose={handleClose}
        salesforceLeadStore={salesforceLeadStore}
        type={type}
        fromGrid={fromGrid}
        currentStep={currentStep}
        cadenceStore={cadenceStore}
      />
    </Grid>
  );
});
